import { hasNutritionistProfile, hasPsychologistProfile, isAdminSelector, isPsychologistSeletor } from "@/utils/selectors";
import { useSelector } from "react-redux"

export const useProfile = () => {
  const isAdmin = useSelector(isAdminSelector);
  const isPsychologist = useSelector(isPsychologistSeletor);
  const hasPsychologist = useSelector(hasPsychologistProfile);
  const hasNutritionist = useSelector(hasNutritionistProfile);

  return {
    isAdmin,
    isPsychologist,
    hasPsychologist,
    hasNutritionist,
    hasSpecialistProfile: hasPsychologist || hasNutritionist,
  };
}
